if (!customElements.get('share-button')) {
  customElements.define('share-button', class ShareButton extends HTMLElement {
    constructor() {
      super();

      this.mainDetailsToggle = this.querySelector('details');

      this.elements = {
        shareButton: this.querySelector('button'),
        shareSummary: this.querySelector('summary'),
        successMessage: this.querySelector('[id^="ShareMessage"]'),
        urlInput: this.querySelector('input')
      }
      this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

      if (navigator.share) {
        this.mainDetailsToggle.setAttribute('hidden', '');
        this.elements.shareButton.classList.remove('hidden');
        this.elements.shareButton.addEventListener('click', () => {
          navigator.share({ url: this.urlToShare, title: document.title }).catch(() => {});
        });
      }
      else {
        this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__input').addEventListener('click', this.copyToClipboard.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__copy').addEventListener('click', this.copyToClipboard.bind(this));
        this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));
      }
    }

    toggleDetails() {
      if (!this.mainDetailsToggle.open) {
        this.elements.successMessage.classList.add('hidden');
        this.elements.successMessage.textContent = '';
        this.elements.shareSummary.focus();
      }
      else {
        setTimeout(() => {
          this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
          document.body.addEventListener('click', this.onBodyClickEvent);
        });
      }
    }

    // ROHO 09/2026: navigator.clipboard ist in mehreren haeufigen Kontexten
    // nicht verfuegbar oder wird abgelehnt - vor allem im Instagram- und
    // Facebook-In-App-Browser. Deshalb immer ein Fallback, damit der Button
    // nicht wirkungslos ist und kein unbehandelter Fehler entsteht.
    copyToClipboard() {
      const value = this.elements.urlInput.value;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(value)
          .then(() => this.onCopySuccess())
          .catch(() => this.legacyCopy(value));
      }
      else {
        this.legacyCopy(value);
      }
    }

    legacyCopy(value) {
      let copied = false;

      try {
        const input = this.elements.urlInput;

        input.removeAttribute('readonly');
        input.focus();
        input.select();
        input.setSelectionRange(0, 99999);
        copied = document.execCommand('copy');
        input.setAttribute('readonly', 'readonly');
      } catch (error) {
        copied = false;
      }

      if (copied) {
        this.onCopySuccess();
      }
      else {
        this.onCopyFailure();
      }
    }

    onCopySuccess() {
      this.elements.successMessage.classList.remove('hidden');
      this.elements.successMessage.textContent = theme.accessibilityStrings.shareSuccess;
    }

    // Letzte Rueckfallebene: Wert markiert stehen lassen, damit der Besucher
    // ihn selbst kopieren kann.
    onCopyFailure() {
      try {
        this.elements.urlInput.removeAttribute('readonly');
        this.elements.urlInput.focus();
        this.elements.urlInput.select();
      } catch (error) {
        // mehr ist hier nicht moeglich
      }
    }

    updateUrl(url) {
      this.urlToShare = url;
      this.elements.urlInput.value = url;
    }

    onBodyClick(event) {
      if (!this.contains(event.target)) this.close();
    }

    close() {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);

      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
  });
}
